// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.form {
  width: 400px;
}
.file-upload-wrapper {
  position: relative;
  width: 100%;
  height: 60px;
}
.file-upload-wrapper:after {
  content: attr(data-text);
  font-size: 18px;
  position: absolute;
  top: 0;
  left: 0;
  background: #fff;
  padding: 10px 15px;
  display: block;
  width: calc(100% - 40px);
  pointer-events: none;
  z-index: 20;
  height: 40px;
  line-height: 40px;
  color: #999;
  border-radius: 5px 10px 10px 5px;
  font-weight: 300;
}
.file-upload-wrapper:before {
  content: 'Upload';
  position: absolute;
  top: 0;
  right: 0;
  display: inline-block;
  height: 60px;
  background: #ff4613;
  color: #fff;
  font-weight: 700;
  z-index: 25;
  font-size: 16px;
  line-height: 60px;
  padding: 0 15px;
  text-transform: uppercase;
  pointer-events: none;
  border-radius: 0 5px 5px 0;
}
.file-upload-wrapper:hover:before {
  background: #ff4613;
}
.file-upload-wrapper input {
  opacity: 0;
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 99;
  height: 40px;
  margin: 0;
  padding: 0;
  display: block;
  cursor: pointer;
  width: 100%;
}



.ticket {
  transition: all 0.4s ease-in-out;
}
.ticket:hover {
  box-shadow: 0px 0px 1rem rgba(0, 0, 0, 0.15);
}

.ticket-row {
  border-color:#edeff1;
  border-style: dashed;
  border:1px dashed #edeff1;
  transition: all 0.2s ease-in-out;
  vertical-align: center;

}

.ticket-row:hover{
  box-shadow: 0px 0px 1rem rgba(0, 0, 0, 0.05);
}

.ticket-table {
  width:96%;
  margin:auto;
  box-shadow: 0px 0px 1rem rgba(0, 0, 0, 0.05);
}

.app_global_search{
  width: 320px;
  .search_input{
    font-size: 0.70rem;
  }
  .search_btn{
    width: 125px;
    font-size: 12px;
  }
}

.rounded-checkbox {
  border-radius: 50%!important;
  height:1rem!important;
  width:1rem!important;
  border: 1px solid #ddd;
  appearance: none;
  -webkit-appearance: none;
  outline: none;
}

.rounded-checkbox:checked {
  background-color: #ff4613;
}


.modal-big {
  width:1200px;
}



.custom-window-class > .modal-dialog,
.custom-window-class > .modal-dialog > .modal-content {
  width: 1200px!important;
  max-width: 1200px!important;
  min-width: 1200px!important;
}










.tab {
  position: relative;
  overflow: hidden;
  cursor: pointer;
}
.tab:after {
  content: '';
  display: block;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 3px;
  position: absolute;
  background-color: #ff4612;
  transition: transform ease 200ms, opacity ease 0ms 200ms;
  transform: translateX(100%);
  opacity: 0;
}
.tabs-wrapper:hover .tabs:not(:hover) .tab:not(.active):first-child::after, .tab:hover ~ .tab:not(.active)::after {
  transform: translateX(-100%);
}
.tabs-wrapper:not(:hover) .tab:not(.active)::after {
  transform: translateY(100%);
}
.tabs:hover .tab:hover::after, .tabs-wrapper:hover .tabs:hover .tab:hover::after {
  transition-delay: 0ms, 0ms;
}
.tab.active::after, .tab:hover::after {
  transform: translateX(0%);
  opacity: 1;
}

p.tab {
  display: inline-block;
  text-decoration: none;
  color: #000;
  padding: 1rem;
}



.tox.tox-edit-area__iframe{
  background-color:blue!important
}

.tox-edit-area__iframe{
  background-color:blue!important
}
.tox{
  background-color:blue!important
}

#addonsLeft{
  transition: all 0.2s ease-in-out;
  min-width:200px;
}
#addonsLeft:hover{
  min-width: 250px
}

.hover-button{
  transition: all 0.2s ease-in-out;
  border-radius:10px;
}
.hover-button:hover {
  background-color:rgba(255,70,19,0.8)
}

/*# sourceMappingURL=data:application/json;base64,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 */`, "",{"version":3,"sources":["webpack://./src/app/containers/ticketing/components/system-fields-directives/repossession-ticket-directive/repossession-ticket-directive.css"],"names":[],"mappings":"AAAA;EACE,YAAY;AACd;AACA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;AACd;AACA;EACE,wBAAwB;EACxB,eAAe;EACf,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,gBAAgB;EAChB,kBAAkB;EAClB,cAAc;EACd,wBAAwB;EACxB,oBAAoB;EACpB,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,WAAW;EACX,gCAAgC;EAChC,gBAAgB;AAClB;AACA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,MAAM;EACN,QAAQ;EACR,qBAAqB;EACrB,YAAY;EACZ,mBAAmB;EACnB,WAAW;EACX,gBAAgB;EAChB,WAAW;EACX,eAAe;EACf,iBAAiB;EACjB,eAAe;EACf,yBAAyB;EACzB,oBAAoB;EACpB,0BAA0B;AAC5B;AACA;EACE,mBAAmB;AACrB;AACA;EACE,UAAU;EACV,kBAAkB;EAClB,MAAM;EACN,QAAQ;EACR,SAAS;EACT,OAAO;EACP,WAAW;EACX,YAAY;EACZ,SAAS;EACT,UAAU;EACV,cAAc;EACd,eAAe;EACf,WAAW;AACb;;;;AAIA;EACE,gCAAgC;AAClC;AACA;EACE,4CAA4C;AAC9C;;AAEA;EACE,oBAAoB;EACpB,oBAAoB;EACpB,yBAAyB;EACzB,gCAAgC;EAChC,sBAAsB;;AAExB;;AAEA;EACE,4CAA4C;AAC9C;;AAEA;EACE,SAAS;EACT,WAAW;EACX,4CAA4C;AAC9C;;AAEA;EACE,YAAY;EACZ;IACE,kBAAkB;EACpB;EACA;IACE,YAAY;IACZ,eAAe;EACjB;AACF;;AAEA;EACE,4BAA4B;EAC5B,qBAAqB;EACrB,oBAAoB;EACpB,sBAAsB;EACtB,gBAAgB;EAChB,wBAAwB;EACxB,aAAa;AACf;;AAEA;EACE,yBAAyB;AAC3B;;;AAGA;EACE,YAAY;AACd;;;;AAIA;;EAEE,uBAAuB;EACvB,2BAA2B;EAC3B,2BAA2B;AAC7B;;;;;;;;;;;AAWA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,WAAW;EACX,cAAc;EACd,SAAS;EACT,OAAO;EACP,WAAW;EACX,WAAW;EACX,kBAAkB;EAClB,yBAAyB;EACzB,wDAAwD;EACxD,2BAA2B;EAC3B,UAAU;AACZ;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,2BAA2B;AAC7B;AACA;EACE,0BAA0B;AAC5B;AACA;EACE,yBAAyB;EACzB,UAAU;AACZ;;AAEA;EACE,qBAAqB;EACrB,qBAAqB;EACrB,WAAW;EACX,aAAa;AACf;;;;AAIA;EACE;AACF;;AAEA;EACE;AACF;AACA;EACE;AACF;;AAEA;EACE,gCAAgC;EAChC,eAAe;AACjB;AACA;EACE;AACF;;AAEA;EACE,gCAAgC;EAChC,kBAAkB;AACpB;AACA;EACE;AACF;;AAEA,okOAAokO","sourcesContent":[".form {\n  width: 400px;\n}\n.file-upload-wrapper {\n  position: relative;\n  width: 100%;\n  height: 60px;\n}\n.file-upload-wrapper:after {\n  content: attr(data-text);\n  font-size: 18px;\n  position: absolute;\n  top: 0;\n  left: 0;\n  background: #fff;\n  padding: 10px 15px;\n  display: block;\n  width: calc(100% - 40px);\n  pointer-events: none;\n  z-index: 20;\n  height: 40px;\n  line-height: 40px;\n  color: #999;\n  border-radius: 5px 10px 10px 5px;\n  font-weight: 300;\n}\n.file-upload-wrapper:before {\n  content: 'Upload';\n  position: absolute;\n  top: 0;\n  right: 0;\n  display: inline-block;\n  height: 60px;\n  background: #ff4613;\n  color: #fff;\n  font-weight: 700;\n  z-index: 25;\n  font-size: 16px;\n  line-height: 60px;\n  padding: 0 15px;\n  text-transform: uppercase;\n  pointer-events: none;\n  border-radius: 0 5px 5px 0;\n}\n.file-upload-wrapper:hover:before {\n  background: #ff4613;\n}\n.file-upload-wrapper input {\n  opacity: 0;\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  z-index: 99;\n  height: 40px;\n  margin: 0;\n  padding: 0;\n  display: block;\n  cursor: pointer;\n  width: 100%;\n}\n\n\n\n.ticket {\n  transition: all 0.4s ease-in-out;\n}\n.ticket:hover {\n  box-shadow: 0px 0px 1rem rgba(0, 0, 0, 0.15);\n}\n\n.ticket-row {\n  border-color:#edeff1;\n  border-style: dashed;\n  border:1px dashed #edeff1;\n  transition: all 0.2s ease-in-out;\n  vertical-align: center;\n\n}\n\n.ticket-row:hover{\n  box-shadow: 0px 0px 1rem rgba(0, 0, 0, 0.05);\n}\n\n.ticket-table {\n  width:96%;\n  margin:auto;\n  box-shadow: 0px 0px 1rem rgba(0, 0, 0, 0.05);\n}\n\n.app_global_search{\n  width: 320px;\n  .search_input{\n    font-size: 0.70rem;\n  }\n  .search_btn{\n    width: 125px;\n    font-size: 12px;\n  }\n}\n\n.rounded-checkbox {\n  border-radius: 50%!important;\n  height:1rem!important;\n  width:1rem!important;\n  border: 1px solid #ddd;\n  appearance: none;\n  -webkit-appearance: none;\n  outline: none;\n}\n\n.rounded-checkbox:checked {\n  background-color: #ff4613;\n}\n\n\n.modal-big {\n  width:1200px;\n}\n\n\n\n.custom-window-class > .modal-dialog,\n.custom-window-class > .modal-dialog > .modal-content {\n  width: 1200px!important;\n  max-width: 1200px!important;\n  min-width: 1200px!important;\n}\n\n\n\n\n\n\n\n\n\n\n.tab {\n  position: relative;\n  overflow: hidden;\n  cursor: pointer;\n}\n.tab:after {\n  content: '';\n  display: block;\n  bottom: 0;\n  left: 0;\n  width: 100%;\n  height: 3px;\n  position: absolute;\n  background-color: #ff4612;\n  transition: transform ease 200ms, opacity ease 0ms 200ms;\n  transform: translateX(100%);\n  opacity: 0;\n}\n.tabs-wrapper:hover .tabs:not(:hover) .tab:not(.active):first-child::after, .tab:hover ~ .tab:not(.active)::after {\n  transform: translateX(-100%);\n}\n.tabs-wrapper:not(:hover) .tab:not(.active)::after {\n  transform: translateY(100%);\n}\n.tabs:hover .tab:hover::after, .tabs-wrapper:hover .tabs:hover .tab:hover::after {\n  transition-delay: 0ms, 0ms;\n}\n.tab.active::after, .tab:hover::after {\n  transform: translateX(0%);\n  opacity: 1;\n}\n\np.tab {\n  display: inline-block;\n  text-decoration: none;\n  color: #000;\n  padding: 1rem;\n}\n\n\n\n.tox.tox-edit-area__iframe{\n  background-color:blue!important\n}\n\n.tox-edit-area__iframe{\n  background-color:blue!important\n}\n.tox{\n  background-color:blue!important\n}\n\n#addonsLeft{\n  transition: all 0.2s ease-in-out;\n  min-width:200px;\n}\n#addonsLeft:hover{\n  min-width: 250px\n}\n\n.hover-button{\n  transition: all 0.2s ease-in-out;\n  border-radius:10px;\n}\n.hover-button:hover {\n  background-color:rgba(255,70,19,0.8)\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
